import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import axios from 'axios';

import {
    buttonProcessGet, responseGet, globalSettings, separatorsNumbersSet, styles, validateDecimals, numberSet, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, languageObjGet, 
    isUndNullEmp, awaitDelay, processEvaluateGet, isUndNull, isNumber
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { taxModelGet } from '../../models/taxes/tax';

const currentMethod = 'TaxAddDetailsEdit';

const { app, collections: dbColle, icons, images, labels, messages, } = globalSettings;
const { backend } = app;
const { html: reactHtml, tempusDominus, } = globalSettings?.react;
const { properties: dbProps, } = dbColle;

const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

export default function TaxAddDetailsEdit({
    $ = {},
    auth = {},
    userRole = {},
    tax = taxModelGet({}),
    setTax = () => { },
    dtId = '',
    dtRowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    setProcessType = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const taxDateId = 'taxDate';
    const [dateError, setDateError] = useState('');
    const [percentageError, setPercentageError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnTaxModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnTaxModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnTaxModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkTaxModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkTaxModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoTaxModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoTaxModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoTaxModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            date: {
                id: 'inputTaxModalDate',
                className: 'form-control datetimepicker-input',
            },
            percentage: {
                id: 'inputTaxModalPercentage',
                className: 'form-control text-right',
            },
            remark: {
                id: 'inputTaxModalRemark',
                className: 'form-control',
            },
        },
        selects: {
            countries: {
                id: 'selTaxModalCountries',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spTaxModalSave',
                className: '',
            },
            back: {
                id: 'spTaxModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (tax)
    const taxAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'taxAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRow = [];
            //#endregion variables

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };

            response = taxDataSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create data (coin)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                tax: tax,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            tax = response?.result || {};
            //#endregion create data (coin)

            //#region dataTable data set
            dataObj = {
                dateTimeOrder: dateTimeFormatGlobalSet({
                    date: tax?.date,
                    type: tempusDominus?.format?.date?.ymdTwo,
                    format: 24,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                dateTime: dateTimeFormatGlobalSet({
                    date: tax?.date,
                    type: languageObj.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                percentage: separatorsNumbersSet({
                    number: tax?.percentage,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                remark: tax?.remark,
            };

            dtRow.push(
                dataObj?.dateTimeOrder,
                dataObj?.dateTime,
                dataObj?.percentage,
                dataObj?.remark,
                buttonProcessGet({
                    id: tax.id,
                    //description: dataObj?.percentage,
                    description: `${dataObj?.remark}§${dataObj?.percentage}`,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: tax,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: processEvaluateGet({
                        object: tax,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.delete?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            );

            $(`#${dtId}`)?.DataTable()?.row?.add(dtRow)?.draw(true);
            //#endregion datatadle data set

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const taxEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'coinEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRow = [];
            //#endregion variables

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };

            response = taxDataSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region tax update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                tax: tax,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/${tax?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            tax = response?.result || {};
            //#endregion tax update

            //#region datatadle data set
            dataObj = {
                dateTimeOrder: dateTimeFormatGlobalSet({
                    date: tax?.date,
                    type: tempusDominus?.format?.date?.ymdTwo,
                    format: 24,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                dateTime: dateTimeFormatGlobalSet({
                    date: tax?.date,
                    type: languageObj.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                percentage: separatorsNumbersSet({
                    number: tax?.percentage,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                remark: tax?.remark,
            };

            dtRow.push(
                dataObj?.dateTimeOrder,
                dataObj?.dateTime,
                dataObj?.percentage,
                dataObj?.remark,
                buttonProcessGet({
                    id: tax.id,
                    //description: dataObj?.percentage,
                    description: `${dataObj?.remark}§${dataObj?.percentage}`,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: tax,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: processEvaluateGet({
                        object: tax,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.delete?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            );

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex).data(dtRow)?.draw(true);
            //#endregion datatadle data set

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (tax)

    //#region methods
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = dateInControlSet({
                date: new Date(),
                taxDate: tax?.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSet = ({
        date = new Date(),
        taxDate = {},
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSet';
        let response = responseGet();
        try {
            //#region variables
            let dataTimeObj = {
                dateTime: '',
                dateFormat: languageObj?.format?.date?.f1,
                timeFormat: 0,
                dateTwoFormat: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: taxDate, subMethod: currentMethod, })?.result) {
                dataTimeObj.dateTime = dateTimeFormatGlobalSet({
                    date: taxDate,
                    type: dataTimeObj?.dateFormat,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dataTimeObj.dateTime = dateTimeFormatGlobalSet({
                    date: date,
                    type: dataTimeObj?.dateFormat,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${taxDateId}`)?.datetimepicker({
                'date': moment(dataTimeObj?.dateTime, dataTimeObj?.dateTwoFormat),
                format: dataTimeObj?.dateTwoFormat,
                default: false,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormData'
        let response = responseGet();
        try {
            //#region variables
            const taxDateTime = $(`#${controls?.inputs?.date?.id}`)?.val();
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: taxDateTime, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: tax?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (!moment?.isDate(tax?.date)) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNull({ data: tax?.percentage, subMethod: currentMethod, })?.result) {
                setPercentageError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (tax?.percentage < neutralValue ||
                !isNumber({ number: tax?.percentage, languageId: languageObj?.id, subMethod: currentMethod, })?.result) {
                setPercentageError(`${messages?.mustBeGreaterThanOrEqualTo?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: tax?.remark, subMethod: currentMethod, })?.result) {
                setRemarkError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setDateError('');
            setRemarkError('');
            setPercentageError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const taxDataSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'taxDataSet';
        let response = responseGet();
        try {
            //#region variables
            const taxDateTime = $(`#${taxDateId}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            tax.date = !isUndNullEmp({ data: taxDateTime, subMethod: currentMethod, })?.result ? taxDateTime : tax?.date;
            tax.percentage = numberSet({
                number: tax?.percentage,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.date?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.percentage?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.remark?.id}`)?.attr({ disabled: processType !== 0, });
            //$(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [showModal]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync(true)}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='coins'
                        src={images?.taxesLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.tax?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => processType === 0 ?
                taxAddPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                processType === 1 ?
                    taxEditPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                    e?.preventDefault()}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? taxAddPostAsync(e) : (processType === 1 ? taxEditPostAsync(e) : e?.preventDefault())}> */}
                    {/* <div className='card card-primary card-outline shadow-lg'> */}
                    {/*header*/}
                    {/* <div className='card-header'>
                        <h6 className='card-title'>
                            <img alt={labels?.tax?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.taxesLogo}></img> - {labels?.tax?.[languageObj?.id]}
                        </h6>
                    </div> */}

                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        //#region add / edit
                        <div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <div className='input-group date'
                                                id={taxDateId}
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${taxDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append'
                                                    data-target={`#${taxDateId}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text'>
                                                        <i className={icons?.calendarAlt}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.percentage?.id}
                                                className={controls?.inputs?.percentage?.className}
                                                maxLength={globalSettings?.documentNumberLength?.percentage}
                                                onChange={(e) => setTax({
                                                    ...tax,
                                                    [dbProps?.percentage]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - percentage', })
                                                })}
                                                onFocus={() => setPercentageError('')}
                                                placeholder={labels?.percentage}
                                                tooltip='tooltip'
                                                title={labels?.percentage}
                                                value={tax?.percentage || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-percentage' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(percentageError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>

                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.remark?.id}
                                                className={controls?.inputs?.remark?.className}
                                                onChange={(e) => setTax({
                                                    ...tax,
                                                    [dbProps?.remark]: e?.target?.value,
                                                })}
                                                onFocus={() => setRemarkError('')}
                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                rows={2}
                                                tooltip='tooltip'
                                                title={labels?.remark?.[languageObj?.id]}
                                                value={tax?.remark || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        //#region add / edit
                        :
                        //#region details
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        dateTimeFormatGlobalSet({
                                            date: tax?.date,
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'lbl - date',
                                        })?.result
                                    }</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.percentage?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: tax?.percentage,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: currentMethod,
                                        })?.result
                                    } %</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{tax.remark || ''}</b>
                                </div>
                            </div>
                        </div>
                        //#endregion details
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}